import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsItemReserveRelease() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const itemReserveRelease = () => {
    startListen({
      eventName: 'premium.ITEM_RESERVE_RELEASE',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, itemId, auctionId, free } = event.context

        updateAuctionCar(auctionId, itemId || carId, (data) => {
          return {
            ...data,
            state: free ? 'SOLD' : 'NOT_SOLD',
          }
        })
      },
    })
  }

  return { itemReserveRelease }
}
